module.exports = __webpack_public_path__ + "static/media/leon.555cf1c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/centers/leon.png
// module id = 620
// module chunks = 0